var _defs, _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCustomAge = function SvgCustomAge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "custom-age_svg__Layer_1",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".custom-age_svg__cls-1,.custom-age_svg__cls-2{fill:none;stroke:#000;stroke-width:1.75px}.custom-age_svg__cls-1{stroke-linejoin:round}.custom-age_svg__cls-2{stroke-miterlimit:10}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.99,
    cy: 11.38,
    r: 1.99,
    className: "custom-age_svg__cls-2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.81,
    cy: 8.3,
    r: 2.4,
    className: "custom-age_svg__cls-2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.81,
    cy: 5.78,
    r: 2.73,
    className: "custom-age_svg__cls-2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.31 15.57h1.37c.72 0 1.31.59 1.31 1.31v4.04H1v-4.04c0-.72.59-1.31 1.31-1.31ZM9.88 13.26h1.85c.97 0 1.76.79 1.76 1.76v5.89H8.12v-5.89c0-.97.79-1.76 1.76-1.76ZM18.72 11.25h2.19c1.15 0 2.09.94 2.09 2.09v7.57h-6.37v-7.57c0-1.15.94-2.09 2.09-2.09Z",
    className: "custom-age_svg__cls-1"
  })));
};
export default SvgCustomAge;